import React from 'react';
import { PollingStationDisplay } from 'components';

const PollingStation = () => {

  return (
    <React.Fragment>
      <div className="p-8 grid grid-cols-2 gap-12">
        <div className="col-span-1">
          <PollingStationDisplay
            year="2024"
            fetchType="api"
          />
        </div>
        <div className="col-span-1">
          <PollingStationDisplay
            year="2020"
            fetchType="file"
          />
        </div>
      </div>
    </React.Fragment>
  );
};

export default PollingStation;
